<div class="bil-icon-text-align">
  <mat-icon *ngIf="data.type==='error'">error</mat-icon>
  <mat-icon *ngIf="data.type==='success'">check_circle</mat-icon>
  <mat-icon *ngIf="data.type==='warning'">report_problem</mat-icon>
  <span class="bil-margin-left-per-2">{{data.text}}</span>
</div>
